import React, { useReducer, useContext } from "react";
import { adminReducer as reducer } from "../reducers/adminReducer";
import { adminActions as actions } from "../actions/adminActions";

const initialValue = {
  admins: null,
  showModal: false,
  currentUser: null,
};

const adminContext = React.createContext();

const AdminContext = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <adminContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </adminContext.Provider>
  );
};

export const useAdminContext = () => React.useContext(adminContext);
export default AdminContext;
